import { Intro } from '../../models';

export default function IntroItem({ data }: { data: Intro }) {
  return (
    <div
      id={data.id}
      className="bg-intro-card-blue rounded-xl py-6 px-3 text-intro-text flex flex-col gap-4 w-full"
    >
      <span className="text-3xl">{data.title}</span>
      <p className="text-sm break-words">{data.introduction}</p>
      {data.imageUrl ? (
        <div>
          <span className="font-semibold w-full">{data.imageDescription}</span>
          <img
            src={data.imageUrl}
            alt={data.imageDescription}
            className="w-full rounded-xl mt-3"
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
